import { render, staticRenderFns } from "./AddNewLive.vue?vue&type=template&id=7d436610"
import script from "./AddNewLive.vue?vue&type=script&lang=js"
export * from "./AddNewLive.vue?vue&type=script&lang=js"
import style0 from "./AddNewLive.vue?vue&type=style&index=0&id=7d436610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports